import { generateBridge } from '../Utility/GenerateBridge';

export type DataBridgeSync = {
    saveData: (data: object) => void;
};

export type DataBridgeAsync = {
    loadData: (endpoint: DataEndpoint) => Promise<any[]>;
    flushData: (endpoint: DataEndpoint) => Promise<boolean>;
};

export enum DataEndpoint {
    Local = 'Local',
    Remote = 'Remote',
    All = 'All',
}

export const Data = generateBridge({
    name: 'Data',
    sync: { saveData: undefined },
    async: { loadData: undefined, flushData: undefined },
    event: {},
});
